// Every internal link's address is decided here.
//
// Pages are built at paths ending in "/" (gatsby-plugin-force-trailing-slashes),
// and that is the form the sitemap lists and every canonical tag names.
// vercel.json 301s the slash-less form to it, so a link without the slash puts
// a redirect in front of every visitor and crawler that follows it. Slugs and
// urls arrive from Contentful typed both ways (9 of the 29 blog slugs end in
// "/", 20 do not), so a link built from one goes through `siteHref` instead of
// trusting the CMS.
//
// MOVED_PATHS is the other half of a page move. The OLD url keeps working
// (vercel.json 301s it, gatsby-node.js registers the hop with Gatsby's client
// router); this map stops the site linking to it at all. Its rows exist because
// the links involved are authored in Contentful (the main nav's "Pricing" item,
// an <a> in one blog post body) and a CMS-only edit does not reach production by
// itself — see SERVICE_AREAS_ITEM in Navbar.js. Once an entry is corrected in
// Contentful its row is dead and can be deleted.
//
// Keys are compared lower-cased and without a trailing slash. A Map, not an
// object literal: a relative href that happened to read `constructor` would
// find Object.prototype's and come back truthy.
const MOVED_PATHS = new Map([["/calculator", "/roofing-cost-calculator-michigan/"]]);

// Links to this site are sometimes written absolute. The origin is carried
// through as typed; only the path changes.
const SITE_ORIGIN = /^https?:\/\/(?:www\.)?roachhomeimprovement\.com(?=[/?#]|$)/i;

// A last segment with a dot names a file (/sitemap-0.xml, a PDF), and files are
// served without the slash.
const withTrailingSlash = (path) => (path.endsWith("/") || /\.[^/]*$/.test(path) ? path : `${path}/`);

// The canonical form of a link to a page on this site. Any other link comes
// back untouched: another host, mailto:, tel:, a bare #fragment.
//   "/financing"                                  -> "/financing/"
//   "/blog/leaking-roof?ref=x#faq"                -> "/blog/leaking-roof/?ref=x#faq"
//   "https://roachhomeimprovement.com/calculator" -> "https://roachhomeimprovement.com/roofing-cost-calculator-michigan/"
export const siteHref = (url) => {
  if (typeof url !== "string") return url;
  const trimmed = url.trim();
  const origin = (SITE_ORIGIN.exec(trimmed) || [""])[0];
  const rest = trimmed.slice(origin.length);
  if (!origin && !/^\/(?!\/)/.test(rest)) return url;
  const [, path, suffix] = /^([^?#]*)([\s\S]*)$/.exec(rest);
  const moved = MOVED_PATHS.get(path.replace(/\/+$/, "").toLowerCase());
  return `${origin}${moved || withTrailingSlash(path || "/")}${suffix}`;
};

// Rewrites the href of every link in a block of CMS html. Markup whose links are
// already canonical comes back character-for-character identical.
export const rewriteSiteLinks = (html) =>
  typeof html === "string"
    ? html.replace(/(\shref\s*=\s*)(["'])([\s\S]*?)\2/gi, (match, attr, quote, href) => {
        const next = siteHref(href);
        return next === href ? match : `${attr}${quote}${next}${quote}`;
      })
    : html;
